import {useEffect} from 'react';
import {analytics} from '@resurs-internal/rb-app-api';
import {config} from '../config';

const pageTitleBlackList = ['card_page'];
const anonymizePageTitle = (pageId: string, title?: string) => {
  if (pageTitleBlackList.includes(pageId)) return '';
  return title;
};

export const usePageView = (pageId: string, title?: string) => {
  return useEffect(() => {
    pageView(pageId, title);
  }, [pageId, title]);
};

export function pageView(pageId: string, title?: string) {
  const prefix = `${config?.clientName}`;
  analytics.pageView({
    pageId: pageId.toLowerCase(),
    pageTitle: anonymizePageTitle(pageId, title),
    pagePath: `${prefix}${window.location.pathname}${window.location.search}`,
  });
}
